import { render, staticRenderFns } from "./ManualTransactionLimitsContainer.vue?vue&type=template&id=11f612cb&"
import script from "./ManualTransactionLimitsContainer.vue?vue&type=script&lang=js&"
export * from "./ManualTransactionLimitsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports